import React from "react";
import Chart from "react-apexcharts";
import { formatSensorKeyLabel } from "../../utils/sensorLabel";

const TimeSeriesChart = ({ data }) => {
  // Generate a random hex color
  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Grouping and threshold extraction
  const groupDataForCharts = () => {
    const keyGroup = {};
    data.forEach((item) => {
      const timestamp = Number(item.ts);
      const value = Number(item.value);
      if (!value) return;

      let keyname = item.key;
      const lastChar = keyname.charAt(keyname.length - 1);
      if (!isNaN(lastChar)) {
        keyname = keyname.slice(0, -1);
      }

   

      if (!keyGroup[keyname]) keyGroup[keyname] = {};
      if (!keyGroup[keyname][item.key]) keyGroup[keyname][item.key] = [];
      keyGroup[keyname][item.key].push([timestamp, value]);
    });

    return { keyGroup };
  };

  // Chart rendering function
  const renderChart = (groupedKeys, title, threshold = {}) => {
    if (!groupedKeys) return null;

    const series = Object.keys(groupedKeys).map((key) => ({
      name: formatSensorKeyLabel(key),
      data: groupedKeys[key],
    }));
console.log( getRandomColor());
    const colors = Object.keys(groupedKeys).map((item) => {
    console.log(item);
      if (item === "Alarm Level") {
       return 'orange';
      }
        if (item === "Action Level") {
       return 'yellow';
      }
        if (item === "Maximum Level") {
       return 'red';
      }

     return  getRandomColor();
  
    });

    const options = {
      chart: {
        type: "line",
        toolbar: {
       show: false
              },
        zoom: { enabled: false },
        animations: { enabled: false },
      },
      colors: colors,
      stroke: { curve: "smooth" },
      xaxis: {
        type: 'datetime',
  labels: {
    rotate: -45,
    formatter: function(value) {
      const date = new Date(value);
      const day = date.getDate().toString().padStart(2, '0');
      const month = date.toLocaleString('en-US', { month: 'short' });
      return `${day} ${month}`;
    },
    style: { fontSize: '12px' }
  },
      tickAmount: 31,
  tickPlacement: 'between', 
      },      yaxis: {
        labels: {
          formatter: (val) => Math.round(val),
        },
      },
      tooltip: {
        x: { format: "dd MMM yyyy HH:mm" },
        y: { formatter: (val) => Math.round(val) },
      },
      title: {
        text: title,
        align: "top",
        itemMargin: {
          horizontal: 15,
          vertical: 5,
        },
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "left",
        floating: false,
        itemMargin: {
          horizontal: 15,
          vertical: 5,
        },
      },
      annotations: {
        yaxis: [
          threshold.alarm && {
            y: threshold.alarm,
            borderColor: "#FFA500",
            borderWidth: 3,
            label: {
              text: "",
              style: {
                color: "#fff",
                background: "#FFA500",
              },
            },
          },
          threshold.action && {
            y: threshold.action,
            borderColor: "#FFD700",
            borderWidth: 3,
            label: {
              text: "",
              style: {
                color: "#000",
                background: "#FFD700",
              },
            },
          },
          threshold.maximum && {
            y: threshold.maximum,
            borderColor: "#FF0000",
            borderWidth: 3,
            label: {
              text: "",
              style: {
                color: "#fff",
                background: "#FF0000",
              },
            },
          },
        ].filter(Boolean),
      },
    };

    return (
      <div style={{ marginBottom: "40px" }}>
        <Chart options={options} series={series} type="line" height={700} />
      </div>
    );
  };

  const { keyGroup } = groupDataForCharts();

  const combinedData = {};
  Object.values(keyGroup).forEach((group) => {
    Object.entries(group).forEach(([key, value]) => {
      combinedData[key] = value;
    });
  });

  // const currentThreshold = thresholds;

  // const renderThresholds = () => {
  //   if (!currentThreshold) return null;

  //   return (
  //     <div
  //       style={{
  //         marginLeft: "26px",
  //         display: "flex",
  //         gap: "20px",
  //         flexWrap: "wrap",
  //       }}
  //     >
  //       {currentThreshold.alarm && (
  //         <div style={{ display: "flex", alignItems: "center" }}>
  //           <span
  //             style={{
  //               width: "13px",
  //               height: "13px",
  //               backgroundColor: "#FFA500",
  //               borderRadius: "50%",
  //               display: "inline-block",
  //               marginRight: "8px",
  //             }}
  //           ></span>
  //           <span>Alarm</span>
  //         </div>
  //       )}
  //       {currentThreshold.action && (
  //         <div style={{ display: "flex", alignItems: "center" }}>
  //           <span
  //             style={{
  //               width: "13px",
  //               height: "13px",
  //               backgroundColor: "#FFD700",
  //               borderRadius: "50%",
  //               display: "inline-block",
  //               marginRight: "8px",
  //             }}
  //           ></span>
  //           <span>Action</span>
  //         </div>
  //       )}
  //       {currentThreshold.maximum && (
  //         <div style={{ display: "flex", alignItems: "center" }}>
  //           <span
  //             style={{
  //               width: "13px",
  //               height: "13px",
  //               backgroundColor: "#FF0000",
  //               borderRadius: "50%",
  //               display: "inline-block",
  //               marginRight: "8px",
  //             }}
  //           ></span>
  //           <span>Maximum</span>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  return (
    <div style={{ padding: 20 }} className="text-capitalize graph">
 
      {renderChart(combinedData)}
    </div>
  );
};

export default TimeSeriesChart;
